(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function () {
      var $slider = $('.slider-c2');

      $slider.slick({
          dots: false,
          infinite: false, // Disable infinite looping
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          autoplay: false,
          prevArrow: '<div class="slick-arrow-previous slick-disabled"><img src="https://cdn.shopify.com/s/files/1/0611/5842/4750/files/Lefttt.png?v=1741082868" class="img-fluid slick-prev previmg"></div>',
          nextArrow: '<div class="slick-arrow-next"><img src="https://cdn.shopify.com/s/files/1/0611/5842/4750/files/Righttt.png?v=1741082868" class="img-fluid slick-next nextimg"></div>',
          responsive: [
              {
                  breakpoint: 1020,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
              }
          ]
      });

      // Disable prev arrow on load
      $('.slick-arrow-previous').addClass('slick-disabled');

      // Check slide position and enable/disable arrows
      $slider.on('afterChange', function (event, slick, currentSlide) {
          if (currentSlide === 0) {
              $('.slick-arrow-previous').addClass('slick-disabled');
          } else {
              $('.slick-arrow-previous').removeClass('slick-disabled');
          }

          if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
              $('.slick-arrow-next').addClass('slick-disabled');
          } else {
              $('.slick-arrow-next').removeClass('slick-disabled');
          }
      });
  });

  } catch(e) { console.error(e); }
})();
})();
